import axios from '@/axios';

/**
 * @typedef {{
 *     id:         number,
 *     username:   string,
 *     first_name: ?string,
 *     last_name:  ?string,
 *     email:      string,
 *     visa:       ?string,
 * }} ReviewRequestUser
 */

export default class ReviewRequest
{
    // ------------------------------------------------------------ MEMBERS

    /** @type {number} */
    id;

    /** @type {?ReviewRequestUser} */
    assigned_to;

    /** @type {?ReviewRequestUser} */
    assigned_by;

    /** @type {Object} */
    order;

    /** @type {Object} */
    entity;

    // ------------------------------------------------------------ CONSTRUCTOR

    constructor(fields = {})
    {
        for(const key of Object.getOwnPropertyNames(this))
        {
            if(fields.hasOwnProperty(key))
            {
                this[key] = fields[key];
            }
        }
    }

    // ------------------------------------------------------------ STATIC

    /**
     * Fetch all active review requests.
     *
     * @param {string} [eid] Entity ID to filter on.
     * @returns {ReviewRequest[]}
     */
    static async fetchActive(eid = '')
    {
        let url = '/api/review-request';
        if(eid !== '')
        {
            url += `?entity_id=${eid}`;
        }

        const response = await axios.get(url);
        return response.data.map(r => new ReviewRequest(r));
    }

    /**
     * Fetch the review attached to a specific order.
     *
     * @param {number} ref The order's reference number.
     * @returns {ReviewRequest}
     */
    static async fetchByOrder(ref)
    {
        const url = `/api/order/${ref}/review-request`;
        const response = await axios.get(url);
        return new ReviewRequest(response.data);
    }
}
